import { FormControl, FormItem, FormMessage } from '@/components/ui/form/form.component';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group/radio-group.component';
import { YesNoQuestion } from '@/gql/graphql';
import { cn } from '@/lib/utils';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';

interface QuestionRadioProps {
  disabled?: boolean;
  unanswered?: boolean;
  field: ControllerRenderProps<FieldValues, string>;
  question: YesNoQuestion;
  handleQuestionAnswer: (question: YesNoQuestion, answer: string) => void;
}

export const QuestionRadio = ({ disabled, unanswered, field, handleQuestionAnswer, question }: QuestionRadioProps) => {
  return (
    <FormControl>
      <div>
        <RadioGroup
          className="flex flex-row h-10 w-full"
          disabled={disabled}
          onValueChange={(value) => {
            field.onChange(value);
            handleQuestionAnswer(question, value);
          }}
          value={field.value}
        >
          <FormItem className="flex flex-row items-center w-full">
            <FormControl className="flex flex-row justify-center items-center">
              <RadioGroupItem
                className={cn('flex w-full h-full', field.value === 'Yes' && 'bg-topbar-bg')}
                data-testid={`question-${question.id}-input-yes-radio`}
                checked={field.value === 'Yes'}
                value="Yes"
              />
            </FormControl>
          </FormItem>
          <FormItem className="flex flex-row items-center w-full">
            <FormControl className="flex flex-row justify-center items-center">
              <RadioGroupItem
                className={cn('flex w-full h-full', field.value === 'No' && 'bg-topbar-bg')}
                data-testid={`question-${question.id}-input-no-radio`}
                checked={field.value === 'No'}
                value="No"
              />
            </FormControl>
          </FormItem>
          {unanswered && (
            <FormItem className="flex flex-row items-center w-full">
              <FormControl className="flex flex-row justify-center items-center">
                <RadioGroupItem
                  className={cn('flex w-full h-full', field.value === 'Unanswered' && 'bg-topbar-bg')}
                  data-testid={`question-${question.id}-input-unanswered-radio`}
                  checked={field.value === 'Unanswered'}
                  value="Unanswered"
                />
              </FormControl>
            </FormItem>
          )}
        </RadioGroup>
        <FormMessage data-testid={`question-${question.id}-input-error-message`} />
      </div>
    </FormControl>
  );
};
